import { ROUTE_NAME } from '@constants';

const reservation = {
  name: ROUTE_NAME.Reservation,
  path: '/reservation',
  redirect: '/reservation/reservation',
  meta: {
    // isDesktop: true,
    breadcrumb: true,
    breadcrumbName: '예약',
    navMenu: true,
    description: '예약을 원하는 날짜와 시간을 선택해 주시기 바랍니다.',
  },
  children: [
    {
      name: ROUTE_NAME.Reservation,
      path: 'reservation',
      component: () => import('@views/reservation/Reservation.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: true,
        breadcrumbName: '실시간예약',
        mobileVisible: true,
      },
    },
    {
      name: ROUTE_NAME.ReservationTimeList,
      path: 'reservation-time-list',
      component: () =>
        import('@views/reservation/mobile/ReservationTimeList.vue'),
      props: true,
      meta: {
        requiresAuth: true,
        breadcrumb: false,
        breadcrumbName: '실시간예약 타임리스트',
      },
    },
    {
      name: ROUTE_NAME.ReservationStatus,
      path: 'reservation-status',
      component: () => import('@views/reservation/ReservationStatus.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: true,
        breadcrumbName: '전체예약 확인/취소',
        mobileVisible: true,
      },
    },
    {
      name: ROUTE_NAME.ReservationWaitStatus,
      path: 'reservation-wait-status',
      component: () => import('@views/reservation/ReservationWaitStatus.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: true,
        breadcrumbName: '대기예약 확인/취소',
        mobileVisible: true,
      },
    },
    {
      name: ROUTE_NAME.ReservationLotteryStatus,
      path: 'reservation-lottery-status',
      component: () =>
        import('@views/reservation/ReservationLotteryStatus.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: true,
        breadcrumbName: '배정신청 확인/취소',
        mobileVisible: true,
      },
    },
  ],
};

export default reservation;
